import {html, PropertyValues, TemplateResult} from "lit";
import {customElement} from "lit/decorators/custom-element.js";
import {property} from "lit/decorators/property.js";
import {AbstractDialogComponent} from "../../ha-dialog/abstract-dialog.component";
import {DialogCommandName} from "../../ha-dialog/dialog-command.enum";

@customElement(`ha-confirm`)
export class HaConfirmComponent extends AbstractDialogComponent {

    @property({type: String})
    public cancelLabel: string = `Abbrechen`;

    @property({type: String})
    public confirmLabel: string = `Ja`;

    @property({type: Object})
    public content: TemplateResult | null = null;

    protected _renderFormFooter(): unknown {
        return html`
            <div class="button-group">
                <button type="button"
                        class="confirm buttonform-marker primary"
                        data-label="${this.confirmLabel}"
                        @click=${this._onClickOkay}
                ></button>
                <button type="button"
                        class="cancel buttonform-marker secondary"
                        data-label="${this.cancelLabel}"
                        @click=${this._onClickCancel}
                ></button>
            </div>
        `
    }

    /**
     * Bug fix (Anke, 2026-09-18 — reported via a missing holder name in the
     * whiteboard/linkboard take-over dialog): this used to `return
     * this.content;` directly (pre-2024-03-17 refactor, commit `db4f1f20`).
     * That refactor introduced the `<header>`/button-group wrapper below but
     * dropped the reference to `this.content` entirely — EVERY
     * `UiHelper.confirm()` call in the app has been rendering an empty body
     * ever since, not just this feature's own dialog. Restored via the same
     * `<header class="formular__header">` + `<main class="formular__main">`
     * shape every other `ha-form-*` dialog already uses (e.g.
     * `ha-dialog-keyword-edit.component.ts`), so `dialogs.css`'s existing
     * `.formular__main` padding/layout rule applies with no new CSS needed.
     */
    protected _renderMainContent(): unknown {
        return html`
            <ha-form-confirm>
                <header class="formular__header">
                    ${this._renderFormFooter()}
                </header>
                <main class="formular__main">
                    ${this.content}
                </main>
            </ha-form-confirm>
        `;
    }

    protected shouldUpdate(_changedProperties: PropertyValues): boolean {
        return !!this.content && super.shouldUpdate(_changedProperties);
    }

    private _onClickCancel(): void {
        this.dispatchCommand<void>({
            command: DialogCommandName.CANCEL,
            payload: void 0
        })
    }

    private _onClickOkay(): void {
        this.dispatchCommand<void>({
            command: DialogCommandName.OKAY,
            payload: void 0
        });
    }
}